export default __webpack_public_path__ + "static/media/gallery - felix_00.1a561e0b.jpg";